import { useContext, useState, useEffect } from "react";
import { navigate } from "raviger";
import axios from "axios";
import { Button, ButtonGroup, Card, Col, Form as BootstrapForm, Modal, Row } from 'react-bootstrap';
import { faMerge, faPencil, faPenSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye, faEyeSlash, faArrowAltCircleLeft, faTimes,
  faPen
} from '@fortawesome/free-solid-svg-icons';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Header from "../components/Header";
import { Checkbox, DropDown, TextInput, ToggleSwitch } from '../components/Form';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';
import LoadingLink from '../components/LoadingLink';
import ActionsDropdown from '../components/ActionsDropdown';

function DispatchTeamMemberManagement({ organization }) {

  // Custom filter option to provide a searchable string to filter on.
  const filterOption = (option, inputValue) => {
    const label = option.data.label;
    return label.toLowerCase().includes(inputValue.toLowerCase());
  };

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  // Regex validators.
  const phoneRegex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

  const [data, setData] = useState({team_members: [], isFetching: false});
  const [filteredData, setFilteredData] = useState([]);
  const [teamMemberFilter, setTeamMemberFilter] = useState('');
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const [showMergeModal, setShowMergeModal] = useState(false);
  const handleMergeClose = (formikProps) => {formikProps.resetForm();setShowMergeModal(false);};
  const [showMemberHideConfirm, setShowMemberHideConfirm] = useState(false);
  const handleMemberHideClose = () => setShowMemberHideConfirm(false);
  const [showMemberShowConfirm, setShowMemberShowConfirm] = useState(false);
  const handleMemberShowClose = () => setShowMemberShowConfirm(false);
  const [options, setOptions] = useState({ftm_options:[], fetching:true});
  const [initialData, setInitialData] = useState({first_name: '', last_name: '', phone: '', agency_id: '', email:'', to_be_deleted: null, operational: false, training: false, organization: state ? state.organization.id : 'undefined'});

  const showHideTeamMember = async (team_member_id, action) => {
    await axios.patch('/evac/api/evacteammember/' + team_member_id + '/', {'action':action})
    .then(response => {
      const index = data.team_members.findIndex(team_member => team_member.id === team_member_id);
      let team_members = [...data.team_members];
      team_members[index] = response.data;
      setData(prevState => ({ ...prevState, "team_members": team_members }));
      setFilteredData(team_members.filter(member => (String(member.first_name).toLowerCase().includes(String(teamMemberFilter).toLowerCase()) || String(member.last_name).toLowerCase().includes(String(teamMemberFilter).toLowerCase()) || String(member.agency_id).toLowerCase().includes(String(teamMemberFilter).toLowerCase()) || String(member.email).toLowerCase().includes(String(teamMemberFilter).toLowerCase()))));
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  const handleDelete = () => {
    axios.delete(`/evac/api/evacteammember/${showModal}/`)
    .then(() => {
      setData(prevState => ({ ...prevState, "team_members":data.team_members.filter(member => member.id !== showModal) }));
      setFilteredData(data.team_members.filter(member => member.id !== showModal));
      setShowModal(false)
    })
    .catch(error => {
      setShowSystemError(true);
    });
  };

  useEffect(() => {
    if (teamMemberFilter) {
      setFilteredData(data.team_members.filter(member => (String(member.first_name).toLowerCase().includes(String(teamMemberFilter).toLowerCase()) || String(member.last_name).toLowerCase().includes(String(teamMemberFilter).toLowerCase()) || String(member.agency_id).toLowerCase().includes(String(teamMemberFilter).toLowerCase()) || String(member.email).toLowerCase().includes(String(teamMemberFilter).toLowerCase()))));
    }
    else {
      setFilteredData(data.team_members);
    }
  }, [teamMemberFilter]);

  const handleHideMemberSubmit = async (bool) => {
    await axios.patch('/evac/api/evacteammember/mass_show_hide/', {'ids':selectedMembers, 'hidden':bool})
    .then(response => {
      setData(prevState => ({...prevState, team_members:prevState.team_members.map(item =>
        selectedMembers.includes(item.id)
          ? { ...item, show: !bool, }
          : item
      )}))
      setFilteredData(prevState => (prevState.map(item =>
        selectedMembers.includes(item.id)
          ? { ...item, show: !bool, }
          : item
      )))
      setSelectedMembers([]);
      handleMemberHideClose();
      handleMemberShowClose();
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchEvacMembers = async () => {

      setData({team_members: [], isFetching: true});
      axios.get('/evac/api/evacteammember/?organization=' + organization, {
        cancelToken: source.token,
      })
      .then(teamMemberResponse => {
        let ftm_options = [];
        teamMemberResponse.data.forEach(ftm => {
          // Build member option list.
          ftm_options.push({value: ftm.id, label: ftm.first_name + ' ' + ftm.last_name + ' - ' + ftm.display_phone + (ftm.agency_id ? ' - ' : '') + ftm.agency_id});
        });
        setData({team_members: teamMemberResponse.data, isFetching: false});
        setFilteredData(teamMemberResponse.data);
        setOptions({ftm_options:ftm_options, fetching:false})
      })
      .catch(error => {
        if (!unmounted) {
          setData({team_members: [], isFetching: false});
          setShowSystemError(true);
        }
      });
    };

  fetchEvacMembers();
  }, []);


  return (
    <>
    <span className="mt-4 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
    <Header>
      <span style={{cursor:'pointer'}} onClick={() => navigate("/" + organization + '/manage/organization')} className="me-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse /></span>
      {state.organization.name} - Manage Field Team Members
    </Header>
    <Row className="ms-0 mb-3" style={{marginRight:"9px"}}>
      <Col xs="4" className="ps-0 pe-0">
        <ButtonGroup className="w-100 border rounded" style={{height:"37px"}}>
          <Button
            type="button"
            className="btn btn-primary"
            onClick={() => { navigate("/" + organization + "/manage/members/new") }}
          >
            Create New Field Team Member
          </Button>
        </ButtonGroup>
      </Col>
      <Col xs="6" className="ps-0 pe-0">
        <BootstrapForm.Control type="text" placeholder="Filter Field Team Members..." onChange={(e) => {
          setTeamMemberFilter(e.target.value);
        }} />
      </Col>
      <Col className="ms-0 ps-0">
        <ActionsDropdown variant="outline-light" title={"Actions"} search={true}>
          <LoadingLink
            onClick={() => {setShowMemberHideConfirm(true);}}
            className="d-block"
            isLoading={false}
            label={"Hide Selected Field Team Members On Map"}
            disabled={selectedMembers.length === 0}
            disabled_text="Must have team members selected."
            >
            <FontAwesomeIcon icon={faEyeSlash} className="fas" inverse />
          </LoadingLink>
          <LoadingLink
            onClick={() => {setShowMemberShowConfirm(true);}}
            className="d-block"
            isLoading={false}
            label={"Show Selected Field Team Members On Map"}
            disabled={selectedMembers.length === 0}
            disabled_text="Must have team members selected."
            >
            <FontAwesomeIcon icon={faEye} className="fas" inverse />
          </LoadingLink>
        </ActionsDropdown>
      </Col>
    </Row>
    <Row className="flex-nowrap">
      <Col style={{minWidth:"50px", maxWidth:"50px", marginLeft:"1px"}}>
          Select
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px", marginLeft:"0px"}}>
          Last Name
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px", marginLeft:"1px"}}>
          First Name
      </Col>
      <Col style={{minWidth:"330px", maxWidth:"330px"}}>
          Email
      </Col>
      <Col style={{minWidth:"150px", maxWidth:"150px"}}>
          Phone
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px", marginLeft:"1px"}}>
          Agency ID
      </Col>
      <Col style={{minWidth:"90px", maxWidth:"90px"}}>
          Operational
      </Col>
      <Col style={{minWidth:"90px", maxWidth:"90px"}}>
          Training
      </Col>
      <Col style={{minWidth:"60px", maxWidth:"60px"}}>
          Hidden
      </Col>
      <Col style={{minWidth:"100px", maxWidth:"100px"}}>
          Actions
      </Col>
    </Row>
    {filteredData.map(team_member => (
      <Card key={team_member.id} className="rounded mb-1" style={{width:"520px"}}>
        <div className="row no-gutters flex-nowrap" style={{marginLeft:"0px"}}>
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", borderTopLeftRadius:"0.25rem", borderBottomLeftRadius:"0.25rem", minWidth:"50px", maxWidth:"50px", backgroundColor:"#615e5e"}}>
            <Checkbox
              id={'select' + team_member.id}
              name={'select' + team_member.id}
              style={{
                transform: "scale(.75)",
                marginRight: "1px",
                marginTop: "-6px",
                marginBottom: "-5px",
                paddingLeft:"13px"
              }}
              onChange={() => {
                if (selectedMembers.includes(team_member.id)) {
                  setSelectedMembers(selectedMembers.filter(team_member_id => team_member_id !== team_member.id));
                }
                else {
                  setSelectedMembers(selectedMembers.concat(team_member.id));
                }
              }}
              checked={selectedMembers.includes(team_member.id)}
            />
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"125px", maxWidth:"125px", backgroundColor:"#615e5e", whiteSpace:"nowrap", overflowX:"hidden", textOverflow:"ellipsis"}} title={team_member.first_name}>
            {team_member.last_name}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"125px", maxWidth:"125px", backgroundColor:"#615e5e", whiteSpace:"nowrap", overflowX:"hidden", textOverflow:"ellipsis"}} title={team_member.last_name}>
            {team_member.first_name}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"330px", maxWidth:"330px", backgroundColor:"#615e5e", whiteSpace:"nowrap", overflowX:"hidden", textOverflow:"ellipsis"}} title={team_member.email}>
            {team_member.email}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"150px", maxWidth:"150px", backgroundColor:"#615e5e"}}>
            {team_member.display_phone}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"125px", maxWidth:"125px", backgroundColor:"#615e5e", whiteSpace:"nowrap", overflowX:"hidden", textOverflow:"ellipsis"}} title={team_member.agency_id}>
            {team_member.agency_id}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"90px", maxWidth:"90px", backgroundColor:"#615e5e"}}>
            {team_member.operational ? "Yes" : "No"}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"90px", maxWidth:"90px", backgroundColor:"#615e5e"}}>
            {team_member.training ? "Yes" : "No"}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"60px", maxWidth:"60px", backgroundColor:"#615e5e"}}>
            {team_member.show ? "No" : "Yes"}
          </Col>
          <Col className="border" style={{paddingRight:"3px", paddingTop:"2px", marginTop: "-1px", fontSize:"13px", minWidth:"100px", maxWidth:"100px", borderTopRightRadius:"0.25rem", borderBottomRightRadius:"0.25rem", backgroundColor:"#615e5e"}}>
            <ActionsDropdown variant="secondary" title={"Actions"} disabled={selectedMembers.length > 0} className="float-end" style={{height:"26px", paddingTop:"0px"}}>
							<LoadingLink
								href={"/" + organization + "/manage/members/edit/" + team_member.id}
								className="d-block"
								isLoading={false}
								label="Update Field Team Member"
								>
								<FontAwesomeIcon icon={faPencil} className="fas" inverse />
							</LoadingLink>
              {team_member.show ?
              <LoadingLink
                onClick={() => showHideTeamMember(team_member.id, 'hide')}
                className="d-block"
                isLoading={false}
                label="Hide Field Team Member on Map"
                >
                <FontAwesomeIcon icon={faEyeSlash} className="fas" inverse />
              </LoadingLink>
              :
              <LoadingLink
								onClick={() => showHideTeamMember(team_member.id, 'show')}
								className="d-block"
								isLoading={false}
								label="Show Field Team Member on Map"
								>
								<FontAwesomeIcon icon={faEye} className="fas" inverse />
							</LoadingLink>
              }
              <LoadingLink
								onClick={() => {setInitialData({first_name: team_member.first_name, last_name: team_member.last_name, phone: team_member.display_phone, agency_id: team_member.agency_id, email: team_member.email, to_be_deleted: null, operational: team_member.operational, training: team_member.training, organization: state ? state.organization.id : 'undefined'});setShowMergeModal(team_member.id);}}
								className="d-block"
								isLoading={false}
								label="Merge Field Team Member With Another"
								>
								<FontAwesomeIcon icon={faMerge} className="fas" inverse />
							</LoadingLink>
              <LoadingLink
								onClick={() => setShowModal(team_member.id)}
								className="d-block"
								isLoading={false}
								label="Remove Field Team Member"
								>
								<FontAwesomeIcon icon={faTimes} className="fas" inverse />
							</LoadingLink>
            </ActionsDropdown>
          </Col>
        </div>
      </Card>
    ))}
    </span>
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Team Member Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        This action will permanently delete this team member. Are you sure you want to proceed?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleDelete}>
          Yes
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
    <Formik
      initialValues={initialData}
      enableReinitialize={true}
      validationSchema={Yup.object({
        first_name: Yup.string()
          .max(50, 'Must be 50 characters or less')
          .required('Required'),
        last_name: Yup.string()
          .max(50, 'Must be 50 characters or less')
          .required('Required'),
        phone: Yup.string()
          .matches(phoneRegex, "Phone number is not valid")
          .required('Required'),
        agency_id: Yup.string()
          .max(20, 'Must be 20 characters or less'),
      })}
      onSubmit={(values, { resetForm }) => {
        axios.put(`/evac/api/evacteammember/${showMergeModal}/merge/`, values)
        .then(() => {
          setData(prevState => ({...prevState, "team_members":prevState.team_members.filter(member => Number(member.id) !== Number(values.to_be_deleted)).map(member => Number(member.id) === Number(showMergeModal) ? { ...member, first_name: values.first_name, last_name: values.last_name, phone: values.phone, agency_id: values.agency_id, email: values.email, operational: values.operational, training: values.training } : member)}));
          setFilteredData(filteredData.filter(member => Number(member.id) !== Number(values.to_be_deleted)).map(member => Number(member.id) === Number(showMergeModal) ? { ...member, first_name: values.first_name, last_name: values.last_name, phone: values.phone, agency_id: values.agency_id, email: values.email, operational: values.operational, training: values.training } : member));
          setOptions(prevState => ({...prevState, "ftm_options":prevState.ftm_options.filter(option => Number(option.value) !== Number(values.to_be_deleted))}));
          resetForm();
          setShowMergeModal(false);
        })
        .catch(error => {
          setShowSystemError(true);
        });
      }}
    >
      {formikProps => (
        <Modal show={showMergeModal} onHide={() => handleMergeClose(formikProps)} dialogClassName="wide-modal">
          <Modal.Header closeButton>
            <Modal.Title>Confirm Team Member Merge</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BootstrapForm>
            <Row>
              <Col xs={12}>
                <label className="mb-2">Merge Into</label>
                <Card.Header>
                  <h5 style={{marginBottom:"0px", marginLeft:"-10px"}}>{options.ftm_options.filter(option => Number(option.value) === Number(showMergeModal)).length ? options.ftm_options.filter(option => Number(option.value) === Number(showMergeModal))[0].label : ""}</h5>
                </Card.Header>
                {/* {selected && showMergeModal && options.ftm_options.length && options.ftm_options.filter(option => Number(option.value) === Number(showMergeModal)).length ? <DropDown
                  id={"ftm_original"}
                  key={Math.random()}
                  name={"ftm_original"}
                  type="text"
                  size="lg"
                  options={options.ftm_options.filter(option => Number(option.value) === Number(showMergeModal))}
                  // value={selected}
                  // onChange={setSelected}
                  isClearable={false}
                  // defaultValue={options.ftm_options.filter(option => Number(option.value) === Number(showMergeModal))[0]}
                  value={options.ftm_options.filter(option => Number(option.value) === Number(showMergeModal))[0].value}
                  // placeholder={options.fetching ? "Loading..." : "Select Field Team Member To Merge With..."}
                  // disabled={true}
                /> : ""} */}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12}>
                <label className="mb-2">From</label>
                <DropDown
                  id={"to_be_deleted"}
                  name={"to_be_deleted"}
                  type="text"
                  size="lg"
                  options={showMergeModal ? options.ftm_options.filter(option => Number(option.value) !== Number(showMergeModal)) : options.ftm_options}
                  isClearable={false}
                  placeholder={options.fetching ? "Loading..." : "Select Field Team Member To Merge With..."}
                  filterOption={filterOption}
                  onChange={(instance) => {
                    formikProps.setFieldValue("to_be_deleted", instance.value ? instance.value : null);
                    formikProps.setFieldValue("email", filteredData.filter(ftm => Number(ftm.id) === Number(showMergeModal))[0].email ? formikProps.values.email : instance.value && filteredData.filter(ftm => ftm.id === instance.value)[0].email ? filteredData.filter(ftm => ftm.id === instance.value)[0].email : '');
                    formikProps.setFieldValue("agency_id", filteredData.filter(ftm => Number(ftm.id) === Number(showMergeModal))[0].agency_id ? formikProps.values.agency_id : instance.value && filteredData.filter(ftm => ftm.id === instance.value)[0].agency_id ? filteredData.filter(ftm => ftm.id === instance.value)[0].agency_id : '');
                    formikProps.setFieldValue("operational", filteredData.filter(ftm => Number(ftm.id) === Number(showMergeModal))[0].operational ? formikProps.values.operational : instance.value && filteredData.filter(ftm => ftm.id === instance.value)[0].operational ? filteredData.filter(ftm => ftm.id === instance.value)[0].operational : false);
                    formikProps.setFieldValue("training", filteredData.filter(ftm => Number(ftm.id) === Number(showMergeModal))[0].training ? formikProps.values.training : instance.value && filteredData.filter(ftm => ftm.id === instance.value)[0].training ? filteredData.filter(ftm => ftm.id === instance.value)[0].training : false);
                  }}
                  disabled={options.fetching ? true : false}
                />
              </Col>
            </Row>
            {data.team_members.length && showMergeModal ? <Row className="mt-3 gx-2">
              <TextInput
                type="text"
                label="First Name*"
                name="first_name"
                id="first_name"
                xs="6"
                value={formikProps.values.first_name || data.team_members.filter(ftm => ftm.id === showMergeModal)[0].first_name}
              />
              <TextInput
                type="text"
                label="Last Name*"
                name="last_name"
                id="last_name"
                xs="6"
                value={formikProps.values.last_name || data.team_members.filter(ftm => ftm.id === showMergeModal)[0].last_name}
              />
            </Row> : ""}
            {data.team_members.length && showMergeModal ? <Row className="mt-3 gx-2">
              <TextInput
                type="text"
                label="Phone*"
                name="phone"
                id="phone"
                xs="6"
                value={formikProps.values.phone || data.team_members.filter(ftm => ftm.id === showMergeModal)[0].display_phone}
              />
              <TextInput
                type="text"
                label="Agency ID"
                name="agency_id"
                id="agency_id"
                xs="6"
                value={formikProps.values.agency_id || data.team_members.filter(ftm => ftm.id === showMergeModal)[0].agency_id}
              />
            </Row> : ""}
            {data.team_members.length && showMergeModal ? <Row className="mt-3 gx-2">
              <TextInput
                type="text"
                label="Email Address"
                name="email"
                id="email"
                value={formikProps.values.email}
              />
            </Row> : ""}
            {data.team_members.length && showMergeModal ? <Row className="mt-3">
              <ToggleSwitch xs={4} name="operational" id="operational" label="Operational" checked={formikProps.values.operational} onChange={(e) => formikProps.setFieldValue('operational', e.target.checked)} />
              <ToggleSwitch xs={4} name="training" id="training" label="Training" checked={formikProps.values.training} onChange={(e) => formikProps.setFieldValue('training', e.target.checked)} />
            </Row> : ""}
          </BootstrapForm>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => formikProps.submitForm()} disabled={formikProps.values.to_be_deleted ? false : true}>
              Merge
            </Button>
            <Button variant="secondary" onClick={() => handleMergeClose(formikProps)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Formik>
    <Modal show={showMemberHideConfirm} onHide={handleMemberHideClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Hide Members</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">
          Are you sure you would like to hide the following team members on the map?
        </p>
        {data.team_members.filter(team_member => selectedMembers.includes(team_member.id)).map(team_member => (
          <div key={team_member.id}>{team_member.first_name} {team_member.last_name}</div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {handleHideMemberSubmit(true)}}>Yes</Button>
        <Button variant="secondary" onClick={handleMemberHideClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showMemberShowConfirm} onHide={handleMemberShowClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Show Members</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">
          Are you sure you would like to show the following team members on the map?
        </p>
        {data.team_members.filter(team_member => selectedMembers.includes(team_member.id)).map(team_member => (
          <div key={team_member.id}>{team_member.first_name} {team_member.last_name}</div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {handleHideMemberSubmit(false)}}>Yes</Button>
        <Button variant="secondary" onClick={handleMemberShowClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

export default DispatchTeamMemberManagement
